<template>
  <ResearchTopicOverviewProxy />
</template>

<script setup lang="ts">
import ResearchTopicOverviewProxy from "~/components/templates/ResearchTopicOverviewProxy.vue";
import { useResearchTopicRouteCache } from "~/composables/useResearchTopicRouteCache";

useResearchTopicRouteCache();
</script>
